import { message } from 'antd';
import FileSaver from 'file-saver';
import { AppInsights } from "applicationinsights-js";

import * as constants from './constants';
import common from '../../common';

export function getIgIoExport() {
    return async (dispatch, getState) => {
        message.info('report generation started.');
        const lang = getState().uistate.appsettings.lang
        try {
            const resp = await common.apiClient.get(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/reporting/igio_reports?lang=${lang}`, { responseType: "arraybuffer" });
            const file = new Blob(
                [resp.data],
                { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
            );

            FileSaver.saveAs(file, 'IkGeefIkOntvangReports.xlsx');
        } catch (error) {
            AppInsights.trackException(error);
        }
    };
}







